// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_qhn","cls2":"PodcastPlayer-cls2_EVE PodcastPlayer-cls1_qhn"};